import React, { useState } from 'react';
import { Form, Collapse } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import sh from 'components/shared.module.css';
import s from './options.module.css';

const DropdownBox = ({ title, children, collapsed }) => {
  const [isCollapsed, toggleCollapse] = useState(collapsed);
  const icon = isCollapsed ? 'eye-slash' : 'eye';
  return (
    <>
      <div
        className={`${s.header} ${s.optionsHeader}`}
        onClick={() => toggleCollapse(!isCollapsed)}
      >
        <div className='d-flex justify-content-between mx-1'>
          <div className={`${(isCollapsed) ? sh.titleSelected : ''}`}>{title}</div>
          <FontAwesomeIcon icon={['far', icon]} color='#404040' style={{ marginTop: 2 }} />
        </div>
      </div>
      <Collapse in={isCollapsed}>
        {children}
      </Collapse>
    </>
  );
};

// .form-control-sm
const Options = () => (
  <div className={`${s.optionsCont} customWidth`}>
    <div className={s.optionsTitle}>Options:</div>
    <DropdownBox title='Preferences'>
      <div className={s.collapsedContentCont}>
        <div className={s.contentCont}>
          <div className='d-flex justify-content-between mx-1'>
            <span>Objects Threshold</span>
            <Form.Control size='sm' type='number' placeholder='0' />
          </div>
          <div className='d-flex justify-content-between mx-1'>
            <span>mode type</span>
            <Form.Control as='select' defaultValue='plain' size='sm'>
              <option value='plain'>Plain</option>
              <option value='expressive'>Expressive</option>
              <option value='like-dislike'>Like-Dislike</option>
            </Form.Control>
          </div>
          <div className='d-flex justify-content-between mx-1'>
            <span>Quantitative Mode</span>
            <Form.Check inline type='checkbox' label='' />
          </div>
        </div>
      </div>
    </DropdownBox>
    <DropdownBox title='Objects Restriction'>
      <div className={s.collapsedContentCont}>
        <div className={s.contentCont}>
          <div className='d-flex justify-content-between mx-1'>
            <span>Objects per page:</span>
            <Form.Control size='sm' type='number' placeholder='100' />
          </div>
          <div className='d-flex justify-content-between mx-1'>
            <span>Show counts in terms of values</span>
            <Form.Check inline type='checkbox' defaultChecked label='' />
          </div>
        </div>
      </div>
    </DropdownBox>
    <DropdownBox title='Pop-Up'>
      <div className={s.collapsedContentCont}>
        <div className={s.contentCont}>
          <div className='d-flex justify-content-between mx-1'>
            <span>Make it sticky:</span>
            <Form.Control as='select' defaultValue='onMouseOver' size='sm'>
              <option value='onMouseOver'>onMouseOver</option>
              <option value='onClick'>onClick</option>
            </Form.Control>
          </div>
          <div className='d-flex justify-content-between mx-1'>
            <span>Showing Delay (sec):</span>
            <Form.Control size='sm' type='number' placeholder='0.2' />
          </div>
        </div>
      </div>
    </DropdownBox>
  </div>
);

export default Options;
